// Material Dashboard 2 React base styles
import colors from 'assets/theme/base/colors';
import boxShadows from 'assets/theme/base/boxShadows';
import borders from 'assets/theme/base/borders';

const { white } = colors;
const { md } = boxShadows;
const { borderRadius } = borders;

const tableContainer = {
  styleOverrides: {
    root: {
      backgroundColor: white.main,
      boxShadow: md,
      borderRadius: borderRadius.xl,
      '& thead > tr > th > div': {
        fontSize: '0.75rem',
        '& svg': {
          width: '1.3em',
          height: '1.3em',
          position: 'relative',
          top: '-2px',
        },
      },
    },
  },
};

export default tableContainer;
